module.exports = __webpack_public_path__ + "static/media/A1-1-Bylub-cod83.ac11fd44.png";